<div class="box" [ngStyle]="getStyle(style)" (clickOutside)="ocClickOut($event)">
  <div
    class="tags {{ required_class }}"
    [class.isHeight]="height ? true : false"
    (click)="showDropdown()"
    [style.height.px]="height"
    [style.borderRadius.px]="borderRadius">
    <span class="placeHolder" *ngIf="selected?.length === 0">{{ placeholder }}</span>
    <ng-container *ngFor="let item of selected; let i = index">
      <div class="selected_one">
        <p class="cursor-pointer" (click)="openRecord(item)">{{ item[optionLabel] }}</p>
        <span (click)="spliceItem(i)" class="pi pi-times-circle"></span>
      </div>
    </ng-container>
    <i class="fas {{ isHide ? 'fa-sort-up' : 'fa-sort-down' }}"></i>
  </div>

  <div class="drop_box {{ selected?.length > 0 && 'h-370px' }}" *ngIf="isHide">
    <div class="flex_one">
      <label class="checkbox select_all style-d" [attr.data]="isAllSelected ? 'Deselect All' : 'Select All'" *ngIf="!isMultiple">
        <input type="checkbox" [checked]="isAllSelected" (click)="onLabelClick($event)" />
        <div class="checkbox__checkmark"></div>
      </label>
      <div class="inpt">
        <input type="text" placeholder="Search" [(ngModel)]="filterStr" class="_input-icon" />
        <span class="pi pi-search search f-14"></span>
      </div>
    </div>
    <p class="my-2 ml-2 cursor-pointer" (click)="createNewItem()" *ngIf="isCreateNew"><i class="pi pi-plus mr-2 f-10"></i>Create New</p>
    <ul *ngIf="selected?.length > 0">
      <li class="selected_count">{{ selected.length }} Selected item</li>
    </ul>
    <ul>
      <ng-container *ngIf="selected?.length > 0">
        <ng-container *ngFor="let item of sortedSelected | filter_pipe: filterStr : optionLabel; let i = index">
          <li
            (click)="addRemove(item)"
            *ngIf="item[optionLabel]"
            tooltipPosition="top"
            [pTooltip]="isEmail ? item[optionLabel] + ' (' + item.email + ')' : (item[optionLabel] | truncate: 30)">
            <label class="checkbox style-d Yes" *ngIf="!isMultiple">
              <input type="checkbox" checked />
              <div class="checkbox__checkmark"></div>
            </label>
            {{ isEmail ? item[optionLabel] + ' (' + item.email + ')' : (item[optionLabel] | truncate: 30) }}
          </li>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="options_list?.length > 0">
        <ng-container *ngIf="not_sorted; else sorted_option">
          <ng-container *ngFor="let item of options_list | filter_pipe: filterStr : optionLabel; let i = index; trackBy: trackByOption">
            <li (click)="addRemove(item)" *ngIf="item[optionLabel]" tooltipPosition="top" [pTooltip]="item[optionLabel]">
              <label class="checkbox style-d" *ngIf="!isMultiple">
                <input type="checkbox" [value]="false" disabled />
                <div class="checkbox__checkmark"></div>
              </label>
              {{ isEmail ? item[optionLabel] + ' (' + item.email + ')' : isTruncate ? (item[optionLabel] | truncate: 30) : item[optionLabel] }}
            </li>
          </ng-container>
        </ng-container>
        <ng-template #sorted_option>
          <ng-container *ngFor="let item of sortedOptions | filter_pipe: filterStr : optionLabel; let i = index; trackBy: trackByOption">
            <li
              (click)="addRemove(item)"
              *ngIf="item[optionLabel]"
              tooltipPosition="top"
              [pTooltip]="
                isEmail ? item[optionLabel] + ' (' + item.email + ')' : isTruncate == false ? item[optionLabel] : (item[optionLabel] | truncate: 30)
              ">
              <label class="checkbox style-d not" *ngIf="!isMultiple">
                <input type="checkbox" [value]="false" disabled />
                <div class="checkbox__checkmark"></div>
              </label>
              {{
                isEmail ? item[optionLabel] + ' (' + item.email + ')' : isTruncate == false ? item[optionLabel] : (item[optionLabel] | truncate: 30)
              }}
            </li>
          </ng-container>
        </ng-template>
      </ng-container>
    </ul>
    <div class="active-inactive-status" *ngIf="deactiveUser || deactiveProject">
      <p>{{ isActiveDeative == true ? (deactiveProject == true ? 'Active Only' : 'Active') : 'Inactive' }}</p>
      <div class="SP-switch">
        <p-inputSwitch [(ngModel)]="isActiveDeative" (onChange)="getActiveDeactiveOptions()"> </p-inputSwitch>
      </div>
    </div>
    <ul *ngIf="options_list?.length === 0 && selected?.length === 0">
      <li>No Record Found</li>
    </ul>
  </div>
</div>
